const footerLinks = [
  { href: "#entrance", label: "最新入口" },
  { href: "#flash", label: "快讯时间线" },
  { href: "#collection", label: "专题合集" },
  { href: "#topics", label: "分类直达" },
  { href: "#guide", label: "使用指南" },
];

export default function Footer() {
  return (
    <footer className="border-t border-stone-200 bg-[#f1e9dc]">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-600 text-white">
                <i className="ri-road-map-line text-lg"></i>
              </span>
              <div className="leading-none">
                <p className="text-lg font-bold tracking-tight text-stone-900">吃瓜线路</p>
                <p className="mt-0.5 text-[11px] font-medium text-orange-700">防走丢 · 永久地址</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-stone-600">
              吃瓜线路持续同步最新备用地址与永久地址，主入口波动时回本页即可一键切换到最新入口，稳稳在线不失联。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <p className="text-sm font-bold text-stone-900">快捷直达</p>
              <ul className="mt-3 flex flex-col gap-2">
                {footerLinks.map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="whitespace-nowrap text-sm text-stone-600 transition-colors hover:text-orange-700">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-sm font-bold text-stone-900">稳定通道</p>
              <ul className="mt-3 flex flex-col gap-2 text-sm text-stone-600">
                <li className="flex items-center gap-1.5"><i className="ri-shield-check-line text-emerald-600"></i>永久地址</li>
                <li className="flex items-center gap-1.5"><i className="ri-refresh-line text-emerald-600"></i>实时备用线路</li>
                <li className="flex items-center gap-1.5"><i className="ri-download-2-line text-emerald-600"></i>客户端通道</li>
              </ul>
            </div>
            <div>
              <p className="text-sm font-bold text-stone-900">访问提示</p>
              <p className="mt-3 text-sm leading-relaxed text-stone-600">
                如遇打不开，请先刷新，仍不行再切换下方备用线路，并把永久地址加入收藏。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-stone-300/70 bg-white/50 p-4 text-xs leading-relaxed text-stone-500">
          <strong className="text-stone-700">使用说明与声明：</strong>
          本页定位为信息入口导航与站点访问指引，仅对公开内容提供索引与备用通道说明，不参与内容生产与观点输出。请理性浏览、友善讨论；各地址以本页公告栏实时提示为准，谨防仿冒站点。
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-stone-300/70 pt-6 text-xs text-stone-500 sm:flex-row">
          <p>© 2026 吃瓜线路 · 备用地址 · 永久地址 · 防走丢导航</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-road-map-line text-orange-600"></i>
            仅作访问入口索引，请妥善保存本页
          </p>
        </div>
      </div>
    </footer>
  );
}